<template>
  <a
    v-if="!mobile"
    class="main-item-wrapper d-flex flex-column position-relative"
  >
    <div class="item_img">
      <img :src="image" alt="favorite image" @click="goTo(link)" />
      <div class="fav-icon-div">
        <img
          src="../../../assets/rtmklik/icon_active_favorite.svg"
          alt="favorite icon"
        />
      </div>
    </div>

    <div class="titleDiv" v-if="title">
      <p class="mb-0 title_text text-left mt-2">{{ title }}</p>
    </div>
    <div class="overlay">
      <div class="w-100 d-flex flex-column justify-content-between">
        <div class="w-100 d-flex flex-column">
          <div v-if="title" class="mb-1">
            <p class="mb-0 title_text_overlay text-left">{{ title }}</p>
          </div>
          <div
            class="d-flex justify-content-start mb-1"
            v-if="classificationLabel"
          >
            <p class="classificationLabel mb-0">
              {{ classificationLabel }}
            </p>
          </div>
          <div class="d-flex justify-content-start" v-if="categoriesLabel">
            <p class="categoryLabel mb-0 long-title text-left">
              {{ categoriesLabel }}
            </p>
          </div>
        </div>

        <div
          class="w-100 d-flex justify-content-start align-items-center flex-row mt-3"
        >
          <div class="icon cursor-pointer" @click="goTo(link)">
            <img src="../../../assets/rtmklik/main-play.svg" alt="play icon" />
          </div>
          <p class="d-none d-lg-block mb-0 label">
            Tonton Sekarang
          </p>
        </div>
      </div>
    </div>
  </a>
  <router-link
    :to="link"
    class="main-item-wrapper d-flex flex-column cursor-pointer position-relative"
    v-else
  >
    <div class="item_img">
      <img v-bind:src="image" @error="imageLoadError($event)" />
      <div class="fav-icon-div">
        <img
          src="../../../assets/rtmklik/icon_active_favorite.svg"
          alt="favorite icon"
        />
      </div>
      <!-- <div class="latest-tag" v-if="latestTag">
        <span class="latest-text">NEW</span>
      </div> -->
    </div>
    <div class="titleDiv" v-if="title">
      <p class="mb-0 title_text text-left mt-2">{{ title }}</p>
    </div>
  </router-link>
</template>

<script>
/* eslint-disable */
import axios from "axios";
export default {
  name: "vod-card-comp",
  props: [
    "image",
    "latestTag",
    "title",
    "description",
    "link",
    "category",
    "data",
    "itemID",
  ],
  data: function() {
    return {
      mobile: false,
      window: {
        width: 0,
      },
      overlayData: this.data,
      classificationLabel: "",
      categoriesLabel: "",
      firstEpisodeLabel: "",
      userId: localStorage.getItem("user_id"),
    };
  },
  methods: {
    imageLoadError(event) {
      event.target.src = noimage;
    },
    goTo(link) {
      this.$router.push(link);
    },

    truncateString(str, num) {
      if (str.length > num) {
        return str.slice(0, num) + "...";
      } else {
        return str;
      }
    },
    handleResizeforCard() {
      this.window.width = window.innerWidth;

      if (this.window.width >= 992) {
        this.mobile = false;
      } else {
        this.mobile = true;
      }
    },
    initData() {
      const classificationFirst =
        this.overlayData &&
        this.overlayData.classification &&
        this.overlayData.classification.title &&
        this.overlayData.classification.title.en_US;

      this.classificationLabel = classificationFirst ? classificationFirst : "";
      // getCategories
      const categoriesFirst =
        this.overlayData &&
        this.overlayData.categories[0] &&
        this.overlayData.categories[0].title &&
        this.overlayData.categories[0].title.en_US;

      this.categoriesLabel = categoriesFirst ? categoriesFirst : "";
    },
  },
  created() {
    window.addEventListener("resize", this.handleResizeforCard);
    this.handleResizeforCard();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResizeforCard);
  },
  mounted() {
    this.initData();
  },
};
</script>

<style scoped>
.main-item-wrapper {
  z-index: 1;
  text-decoration: none;
}

.item_img {
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  padding-top: calc(349 / 270 * 100%);
  z-index: 1;
}
.item_img img {
  background: 100%;
  width: 100%;
  height: 100%;
  overflow: hidden;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  position: absolute;
  z-index: 2;
}
.label {
  color: #fff;
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-align: left;
}
.main-item-wrapper .overlay {
  display: none;
}
.title_text_overlay {
  color: #fff;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
@media only screen and (min-width: 992px) {
  .main-item-wrapper:hover .titleDiv {
    display: none;
  }
  .main-item-wrapper:hover .item_img {
    padding-top: calc(349 / 270 * 100%);
  }
  .main-item-wrapper:hover .overlay {
    display: block;
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 14;
    width: 100%;
  }
  .main-item-wrapper:hover .overlay {
    display: block;
    position: absolute;
    top: 99%;
    left: 0;
    z-index: 14;
    width: 100%;
  }
}
.tags-wrapper {
  width: 45px;
  padding: 2px 4px;
  height: 20px;
  position: absolute;
  right: 0;
  top: 8px;
  background-color: #f00;
  z-index: 4;
}
.tags-text {
  font-size: 12px;
  font-family: "HelveticaNeue-Bold";
  font-weight: bold;
  line-height: 1.25;
  text-align: left;
  color: #fff;
  z-index: 4;
}

.title_text {
  color: #fff;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.fav-icon-div {
  position: absolute;
  right: 8px;
  bottom: 8px;
  width: 32px;
  height: 32px;
  z-index: 4;
}
.classificationLabel {
  color: #fff;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 130%;
}
.categoryLabel {
  color: #fff;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.icon {
  width: 32px;
  height: 32px;
  margin-right: 8px;
}
.icon img {
  width: 100%;
  height: 100%;
}
.overlay {
  background: #171f26;
  padding: 8px 16px 16px;
  border-radius: 0 0 8px 8px;
  min-height: 108px;
}
.title_text_overlay {
  color: #fff;
  font-family: Inter;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
@media only screen and (max-width: 992px) {
  .item_img {
    filter: saturate(100%);
  }
}
@media only screen and (max-width: 480px) {
  .fav-icon-div {
    width: 24px;
    height: 24px;
    z-index: 4;
  }
}
</style>
<style>
@media only screen and (max-width: 480px) {
}
</style>
